const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR
const WEEK = 7 * DAY
const MONTH = 30 * DAY
const YEAR = 12 * MONTH

export const Time = { SECOND, MINUTE, HOUR, DAY, WEEK, MONTH, YEAR } as const
